import { IBranchRequest } from "./branch.model";
import { DocumentUrl } from "./cartable.model";

export interface StorePage {
  paginationInfo: PaginationInfo | undefined;
  filter: Filter | undefined;
}

export class PaginationInfo {
  pageNumber: number | undefined;
  pageSize?: number = 10;
}

export class Filter {
  isActive: boolean | undefined;
  title: string | undefined;
  storeIds?: number[] | undefined;
}

export interface GetStoreListResponse {
  id: number;
  title: string;
  percentage: string;
  settlementDeadlineDays: number;
  isActive: boolean;
}

export interface AddStoreRequest {
  isActive: boolean;
  title: string;
  logo?: DocumentUrl;
  bannerLarge?: DocumentUrl;
  bannerMedium?: DocumentUrl;
  bannerSmall?: DocumentUrl;
  settlementDeadlineDays: number;
  settlementPercentage: number;
  sortIndex: number;
  description: string;
  walletTypeIds: number[];
  storeCategories: StoreCategorie[];
}
export interface IStoreID {
  storeId: number;
  isEdit?: boolean;
}
export interface GetStoreResponse {
  isActive: boolean;
  title: string;
  logo: string;
  bannerLarge: string;
  bannerMedium: string;
  bannerSmall: string;
  settlementDeadlineDays: number;
  settlementPercentage: number;
  sortIndex: number;
  description: string;
  storeCategories: StoreCategory[];
  branches: IBranchRequest[];
  walletTypeIds: number[];
  logoUrl: string;
  bannerUrl: string;
}

export class StoreCategorie {
  categoryId: number | undefined;
  settlementPercentage: number | undefined;
}

export interface AddLogoRequest {
  storeId: number;
  file: DocumentUrl;
  bannerSize: string;
}
export interface DeleteLogoRequest {
  storeId: number;
}
export interface DeleteBannerRequest {
  storeId: number;
  bannerSize: string;
}
export interface AddOrUpdateCategoryRequest {
  storeId: number;
  categoryId: number;
  settlementPercentage: number;
}
export interface AddOrUpdateCategoryResponse {
  storeCategoryId: number;
  categoryId: number;
  name: string;
  settlementPercentage: number;
  icon: string;
}
export interface DeleteCategoryRequest {
  storeCategoryId: number;
}
export interface EditStoreRequest {
  storeId: number;
  title: string;
  settlementDeadlineDays: number;
  settlementPercentage: number;
  sortIndex: number;
  description: string;
  isActive: boolean;
  walletTypeIds: number[];
}
interface StoreCategory {
  storeCategoryId: number;
  categoryId: number;
  name: string;
  settlementPercentage: number;
  icon: string;
}
// export interface Branch {
//   branchId: number;
//   title: string;
//   branchType: string;
//   branchTypeTitle: string;
//   isActive: boolean;
//   iban: string;
//   address: Address;
//   url: string;
// }
interface Address {
  postalCode: string;
  cityName: string;
  address: string;
}

export interface GetCategoriesByStoreIdResponse {
  storeCategoryId: number;
  categoryId: number;
  categoryTitle: string;
  storeId: number;
  settlementPercentage: number;
  categoryLogoBase64: string;
}
